import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3.75,
			y: 3.75,
			width: 16.5,
			height: 16.5,
			rx: 8.25,
			stroke: "url(#paint0_linear_22_8444)",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 6,
			fill: "url(#paint1_linear_22_8444)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_22_8444",
			x1: 3,
			y1: -12.5455,
			x2: 16.3977,
			y2: 23.3523,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#2E22FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#15B6EA"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_22_8444",
			x1: 6,
			y1: -4.36364,
			x2: 14.9318,
			y2: 19.5682,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#2E22FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#15B6EA"
			})]
		})] })
	]
});
export default SvgRadioChecked;
